/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type OutletListDTO = {
  address?: string;
  availableBalance?: number;
  balance?: number;
  commissionWalletId?: number;
  createdAt?: string;
  email?: string;
  id?: string;
  isCurrent?: boolean;
  isDefault?: boolean;
  isWithdrawEnabled?: boolean;
  ledgerBalance?: number;
  location?: string;
  name?: string;
  numberOfPos?: number;
  /**
   * The image the merchant uploaded for this outlet, as a data URL
   * (`data:image/png;base64,...`). Only present on outlets that have one.
   * Not in the generated client yet.
   */
  outletImage?: string;
  phoneNumber?: string;
  status?: OutletListDTO.status;
  updatedAt?: string;
  wallet?: string;
  walletId?: number;
};

export namespace OutletListDTO {
  export enum status {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
  }
}
